import { StorageKey } from '../../../auth/web-store-api/enums';
import { Customer } from '../../models';
import { getPricingHeaders } from '../../utilities';
import { getPricingApiConfig, pricingHttp } from '../pricing-api';

/**
 * Fetches customer information from the pricing API.
 *
 * @returns {Promise<Customer | null>} Customer details if found, or `null` if not.
 */
export const getCustomerInfo = async (): Promise<Customer | null> => {
  try {
    const { isSFCCPricingOn, shopApiClientId } = getPricingApiConfig();

    if (!isSFCCPricingOn) {
      console.warn('SFCC Pricing is not enabled.');
      return null;
    }

    const customerId =
      localStorage.getItem(StorageKey.CustomerAuthId) ||
      localStorage.getItem(StorageKey.CustomerGuestId);

    if (!customerId) {
      console.warn('Customer ID not found in localStorage.');
      return null;
    }

    const requestConfig = await getPricingHeaders(shopApiClientId);
    const extensionQuery = 'checkIfIsEPPCustomer=true';
    const endpoint = `customers/${customerId}?${extensionQuery}`;

    const response = await pricingHttp.get<Customer>(endpoint, requestConfig);
    return response.data;
  } catch (error) {
    console.error('Error fetching customer info:', error);
    return null;
  }
};
